import Resource from "./resource";

export class LetsEncryptConfigurationResource extends Resource {
    Enabled: boolean;
    RegistrationEmailAddress: string;
    DnsName: string;
    HttpsPort: number;
    IPAddress: string;
    AcceptLetsEncryptTermsOfService: boolean;
    CertificateExpiryDate: string;
    CertificateThumbprint: string;
    Path: string;
}

export default LetsEncryptConfigurationResource;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/letsEncryptConfigurationResource.ts